<template>
  <div class="row">
    <div class="container">
      <profile-card></profile-card>
      <card>
        <h4 slot="header" class="card-title">
          {{ $t("message.subscription") }}
        </h4>
        <div class="row">
          <div class="col-6">
            <span class="text-muted">
              {{ $t("message.subscriptionPlan") }}
            </span>
          </div>
          <div class="col-6">
            <span
              v-if="subscription.trialPeriod"
              class="badge badge-danger m-0"
              >{{ $t("message.subscriptionFreeTrial") }}</span
            >
            <span v-else class="badge badge-success m-0">{{ plan.title }}</span>
          </div>
        </div>
        <hr />
        <div
          v-if="subscription.trialPeriod || subscription.cancelledDate"
          class="row align-items-center"
        >
          <div class="col-6">
            <span class="text-muted">
              {{ $t("message.subscriptionEndDate") }}
            </span>
          </div>
          <div class="col-6">
            <span>
              <strong>{{ subscription.endDate | dateToHuman }}</strong>
            </span>
            <span
              class="badge badge-danger ml-3 mb-0"
              v-if="subscription.cancelledDate"
              >{{ $t("message.subscriptionCancelled") }}</span
            >
          </div>
        </div>
        <div v-else class="row">
          <div class="col-6">
            <span class="text-muted">
              {{ $t("message.subscriptionNextBill") }}
            </span>
          </div>
          <div class="col-6">
            <span>
              <strong>€{{ plan.price }}</strong>
              {{ $t("message.on") }}
              <strong>{{ subscription.endDate | dateToHuman }}</strong>
            </span>
          </div>
        </div>
        <hr />
        <div v-if="saasShop">
          <p class="text-muted mb-3">
            <small>
              Every shop is €{{ saasView.price }} a month except Boxx Finglas.
            </small>
          </p>
          <n-button
            v-if="!saasView.active"
            type="primary"
            round
            :busy="billingBusy"
            @click.native="paySaas"
          >
            Pay €{{ saasView.price }} / month
          </n-button>
          <p v-else class="text-muted">
            <small>
              Next bill €{{ saasView.price }} on
              {{ saasView.endDate | dateToHuman }}. Email
              support@smartbooks365.com to cancel.
            </small>
          </p>
        </div>
        <p v-else class="text-muted">
          <small>
            Please contact support@smartbooks365.com if you wish to change your
            subscription.
          </small>
        </p>
      </card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { dateToHuman } from "@/helpers/helpers";
import { saasSubscriptionView, SAAS_PLAN } from "@/helpers/saasBilling";
import ProfileCard from "./ProfileCard";

export default {
  components: {
    ProfileCard
  },
  data() {
    return {
      loader: null,
      isProfileFormVisible: false,
      billingBusy: false
    };
  },
  methods: {
    ...mapActions([
      "fetchPlans",
      "fetchSubscription",
      "startSaasCheckout",
      "confirmSaasCheckout"
    ]),
    checkoutUrls() {
      const origin =
        (typeof window !== "undefined" && window.location && window.location.origin) ||
        "https://app.smartbooks365.com";
      return {
        success_url: `${origin}/account?saas_checkout=success&session_id={CHECKOUT_SESSION_ID}`,
        cancel_url: `${origin}/account?saas_checkout=cancel`
      };
    },
    async paySaas() {
      this.billingBusy = true;
      try {
        await this.startSaasCheckout(this.checkoutUrls());
      } catch (error) {
        this.$notify({
          type: "danger",
          title: this.$t("message.error"),
          text: (error && error.message) || "Could not open card checkout."
        });
      } finally {
        this.billingBusy = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "userToken",
      "userId",
      "userClaims",
      "subscription",
      "subscriptionIsTrialPeriod",
      "subscriptionIsCancelled",
      "plans",
      "isSaasBilledTenant"
    ]),
    ...mapGetters({ shop: "shops/shop" }),
    saasShop() {
      return this.isSaasBilledTenant;
    },
    saasView() {
      return saasSubscriptionView(this.subscription);
    },
    plan() {
      if (this.saasShop) {
        return { title: SAAS_PLAN.title, price: SAAS_PLAN.price };
      }
      return this.plans[this.subscription.plan] || {};
    }
  },
  filters: {
    dateToHuman
  },
  async created() {
    this.fetchPlans();
    if (this.$route.query.saas_checkout === "success" && this.$route.query.session_id) {
      try {
        await this.confirmSaasCheckout(this.$route.query.session_id);
        await this.fetchSubscription();
      } catch (error) {
        this.$notify({
          type: "danger",
          title: this.$t("message.error"),
          text: (error && error.message) || "Could not confirm that card."
        });
      }
    }
  }
};
</script>
